/**
 * URL to the PatientPop Demo Form
 * @constant
 * @type {string}
 */
var PATIENTPOP_WEBSITE = 'https://www.patientpop.com/kareo-customer-demo/?utm_source=Inbound&utm_medium=In-Product&utm_campaign=customer-portal';
/**
 * The user, practice, and customer will create a URL to populate the Patient Pop Demo Form
 * @returns {string} - Returns an URL
 */
export var getPatientPopDemoUrl = function (segmentationInfo) {
    var _a, _b, _c;
    var PATIENTPOP_WEBSITE_WITH_PARAMS = PATIENTPOP_WEBSITE;
    if (!!(segmentationInfo === null || segmentationInfo === void 0 ? void 0 : segmentationInfo.user)) {
        PATIENTPOP_WEBSITE_WITH_PARAMS += segmentationInfo.user.userName
            ? "&email=" + segmentationInfo.user.userName
            : '';
        PATIENTPOP_WEBSITE_WITH_PARAMS += segmentationInfo.user.firstName
            ? "&first_name=" + segmentationInfo.user.firstName
            : '';
        PATIENTPOP_WEBSITE_WITH_PARAMS += segmentationInfo.user.lastName
            ? "&last_name=" + segmentationInfo.user.lastName
            : '';
    }
    if (!!((_a = segmentationInfo === null || segmentationInfo === void 0 ? void 0 : segmentationInfo.user) === null || _a === void 0 ? void 0 : _a.roles) &&
        ((_b = segmentationInfo === null || segmentationInfo === void 0 ? void 0 : segmentationInfo.user) === null || _b === void 0 ? void 0 : _b.roles.length) > 0) {
        PATIENTPOP_WEBSITE_WITH_PARAMS += "&user_roles=" + ((_c = segmentationInfo === null || segmentationInfo === void 0 ? void 0 : segmentationInfo.user) === null || _c === void 0 ? void 0 : _c.roles.map(function (role) { return role.name; }).join('|'));
    }
    if (!!(segmentationInfo === null || segmentationInfo === void 0 ? void 0 : segmentationInfo.practice)) {
        PATIENTPOP_WEBSITE_WITH_PARAMS += (segmentationInfo === null || segmentationInfo === void 0 ? void 0 : segmentationInfo.practice.name) ? "&practice_name=" + (segmentationInfo === null || segmentationInfo === void 0 ? void 0 : segmentationInfo.practice.name)
            : '';
        PATIENTPOP_WEBSITE_WITH_PARAMS += (segmentationInfo === null || segmentationInfo === void 0 ? void 0 : segmentationInfo.practice.phoneNumber) ? "&practice_phone=" + (segmentationInfo === null || segmentationInfo === void 0 ? void 0 : segmentationInfo.practice.phoneNumber)
            : '';
        PATIENTPOP_WEBSITE_WITH_PARAMS += (segmentationInfo === null || segmentationInfo === void 0 ? void 0 : segmentationInfo.practice.zip) ? "&practice_zip=" + (segmentationInfo === null || segmentationInfo === void 0 ? void 0 : segmentationInfo.practice.zip)
            : '';
    }
    if (!!(segmentationInfo === null || segmentationInfo === void 0 ? void 0 : segmentationInfo.practiceSpecialty)) {
        PATIENTPOP_WEBSITE_WITH_PARAMS += "&practice_specialty=" + (segmentationInfo === null || segmentationInfo === void 0 ? void 0 : segmentationInfo.practiceSpecialty);
    }
    if (!!(segmentationInfo === null || segmentationInfo === void 0 ? void 0 : segmentationInfo.providerCount)) {
        PATIENTPOP_WEBSITE_WITH_PARAMS += "&providers=" + (segmentationInfo === null || segmentationInfo === void 0 ? void 0 : segmentationInfo.providerCount);
    }
    if (!!(segmentationInfo === null || segmentationInfo === void 0 ? void 0 : segmentationInfo.userType)) {
        PATIENTPOP_WEBSITE_WITH_PARAMS += "&user_type=" + segmentationInfo.userType;
    }
    // Do not require URL Encoding because Intercom will encode it.
    return PATIENTPOP_WEBSITE_WITH_PARAMS;
};
export default {
    getPatientPopDemoUrl: getPatientPopDemoUrl,
};
